import React from "react";
import PropTypes from "prop-types";
import { Heading, Flex, Text } from "@badi/badi-components";
import { translate } from "base/shared/Localization";

import { getHomePath } from "Sections/Home/routes";
import { getRentRoomPath } from "Sections/Room/routes";

import Menu, {
  MenuItemButton,
  MenuItemLink,
  MenuItemSeparator,
} from "../reponsive-menu";

const PublicMenu = ({ onLogin, onListRoomClick, onRegister }) => (
  <Menu>
    <MenuItemLink dataQa="topbar-public-menu-home" to={getHomePath()}>
      {translate("topbar.element.home.title")}
    </MenuItemLink>
    <MenuItemSeparator />
    <MenuItemLink
      dataQa="topbar-public-menu-download"
      external={true}
      to="https://app.adjust.com/drpyca?campaign=mobileweb_menu&adgroup=link&creative=link_1"
    >
      {translate("topbar.element.download.title")}
    </MenuItemLink>
    <MenuItemLink
      dataQa="topbar-public-menu-rent-button"
      imageSrc="/assets/images/room-info-menu.svg"
      onClick={onListRoomClick}
      to={getRentRoomPath()}
    >
      <Flex direction="column">
        <Heading as="span" level="16-Medium">
          {translate("topbar.element.rentyourroom.title")}
        </Heading>
        <Text body="14-Regular">
          {translate("topbar.element.rentroom.description")}
        </Text>
      </Flex>
    </MenuItemLink>
    <MenuItemSeparator />
    <MenuItemButton dataQa="topbar-public-menu-register" onClick={onRegister}>
      {translate("topbar.element.signup.title")}
    </MenuItemButton>
    <MenuItemButton dataQa="topbar-public-menu-login" onClick={onLogin}>
      {translate("topbar.element.signin.title")}
    </MenuItemButton>
  </Menu>
);

PublicMenu.propTypes = {
  onListRoomClick: PropTypes.func.isRequired,
  onLogin: PropTypes.func.isRequired,
  onRegister: PropTypes.func.isRequired,
};

export default PublicMenu;
